import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { values } from '@/mocks/site';

export default function Values() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-foreground-950/10" />
      <div className="container-wide">
        <div className="grid gap-12 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16">
          <Reveal variant="fade">
            <div className="relative h-full min-h-[420px] overflow-hidden rounded-lg bg-foreground-950">
              <img
                src="https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.23.jpeg"
                alt="Techniciens SGSCTIC préparant une structure métallique sur chantier"
                title="Sécurité et qualité sur chantier industriel"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-7">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-400/70 text-primary-400">
                    <i className="ri-shield-check-line text-lg" />
                  </span>
                  <div>
                    <p className="label-mono text-background-300">Priorité absolue</p>
                    <p className="font-heading text-xl uppercase tracking-wide text-background-50">
                      Sécurité &amp; qualité
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <SectionHeading
                label="Pourquoi SGSCTIC"
                title={
                  <>
                    Des engagements
                    <br />
                    qui tiennent
                    <br />
                    sur le terrain
                  </>
                }
                description="Nous ne promettons pas seulement de la qualité : nous l'organisons. Chaque intervention répond à des procédures, des contrôles et une culture sécurité partagée."
              />
            </Reveal>

            <div className="mt-9 grid gap-4 sm:grid-cols-2">
              {values.map((value, index) => (
                <Reveal key={value.title} delay={index * 90}>
                  <div className="group h-full rounded-lg border border-foreground-950/10 bg-background-100 p-5 transition-colors duration-300 hover:border-primary-400">
                    <div className="flex items-center justify-between">
                      <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-colors duration-300 group-hover:bg-accent-500 group-hover:text-foreground-950">
                        <i className={`${value.icon} text-xl`} />
                      </span>
                      <span className="font-label text-[10px] tracking-[0.2em] text-foreground-400">
                        0{index + 1}
                      </span>
                    </div>
                    <h3 className="mt-5 font-heading text-xl font-semibold uppercase text-foreground-950">
                      {value.title}
                    </h3>
                    <p className="mt-2 text-xs leading-relaxed text-foreground-600">{value.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}